import { computed, inject, Injectable } from '@angular/core';
import { HeaderStateService } from './header-state.service';

@Injectable({
  providedIn: 'root'
})
export class ComponentLoaderService {
  private readonly headerState = inject(HeaderStateService);

  readonly shouldLoadMyTrips = computed(() => {
    const condition =
      this.headerState.selectedNav() ===
      this.headerState.navigationType.myTrips;
    if (condition && !this.headerState.loadedComponents.myTrips) {
      this.headerState.loadedComponents.myTrips = true;
    }
    return this.headerState.loadedComponents.myTrips;
  });

  readonly shouldLoadCheckIn = computed(() => {
    const condition =
      this.headerState.selectedNav() ===
      this.headerState.navigationType.checkIn;
    if (condition && !this.headerState.loadedComponents.checkIn) {
      this.headerState.loadedComponents.checkIn = true;
    }
    return this.headerState.loadedComponents.checkIn;
  });

  readonly shouldLoadFlightStatus = computed(() => {
    const condition =
      this.headerState.selectedNav() ===
      this.headerState.navigationType.flightStatus;
    if (condition && !this.headerState.loadedComponents.flightStatus) {
      this.headerState.loadedComponents.flightStatus = true;
    }
    return this.headerState.loadedComponents.flightStatus;
  });

  readonly shouldLoadFlights = computed(() => {
    const condition =
      this.headerState.selectedNav() === this.headerState.navigationType.book &&
      this.headerState.selectedBookingTab() ===
        this.headerState.bookingCategoryType.flights;
    if (condition && !this.headerState.loadedComponents.flights) {
      this.headerState.loadedComponents.flights = true;
    }
    return this.headerState.loadedComponents.flights;
  });

  readonly shouldLoadVacations = computed(() => {
    const condition =
      this.headerState.selectedNav() === this.headerState.navigationType.book &&
      this.headerState.selectedBookingTab() ===
        this.headerState.bookingCategoryType.vacations;
    if (condition && !this.headerState.loadedComponents.vacations) {
      this.headerState.loadedComponents.vacations = true;
    }
    return this.headerState.loadedComponents.vacations;
  });

  readonly shouldLoadCars = computed(() => {
    const condition =
      this.headerState.selectedNav() === this.headerState.navigationType.book &&
      this.headerState.selectedBookingTab() ===
        this.headerState.bookingCategoryType.cars;
    if (condition && !this.headerState.loadedComponents.cars) {
      this.headerState.loadedComponents.cars = true;
    }
    return this.headerState.loadedComponents.cars;
  });

  readonly shouldLoadStays = computed(() => {
    const condition =
      this.headerState.selectedNav() === this.headerState.navigationType.book &&
      this.headerState.selectedBookingTab() ===
        this.headerState.bookingCategoryType.stays;
    if (condition && !this.headerState.loadedComponents.stays) {
      this.headerState.loadedComponents.stays = true;
    }
    return this.headerState.loadedComponents.stays;
  });
}
